export type BootTag = 'A' | 'T' | 'G';
export type BootMode = 'basic' | 'advanced';
export type BootItemSource = 'manual' | 'imported' | 'suggested';

export interface BootItemMetadata {
  role?: string;
  commitment?: boolean;
  lever?: boolean;
  question?: boolean;
  research?: boolean;
}

export interface BootItem {
  id: string;
  text: string;
  tags: BootTag[];
  rankWithinTag?: number;
  clarified: boolean;
  source: BootItemSource;
  sourceRef?: string;
  metadata?: BootItemMetadata;
}

export interface BootTopThree {
  a1?: string;
  t2?: string;
  g3?: string;
}

export interface BootTimebox {
  scheduledAt?: string;
  provider?: string;
}

export interface BootAdvancedState {
  rolesScanned: string[];
  commsReviewed: boolean;
  researchItems: string[];
  highlightedItemIds: string[];
}

export interface BootSession {
  id: string;
  date: string;
  mode: BootMode;
  step: number;
  items: BootItem[];
  topThree: BootTopThree;
  todayFocus?: string;
  timebox?: BootTimebox;
  advanced?: BootAdvancedState;
  completedAt?: string;
}

export interface MorningBootSettings {
  mode: BootMode;
  preferredTime?: 'morning' | 'evening';
}

export interface MorningBootState {
  backlog: BootItem[];
  sessions: BootSession[];
  settings: MorningBootSettings;
}

export const DEFAULT_MORNING_BOOT_STATE: MorningBootState = {
  backlog: [],
  sessions: [],
  settings: { mode: 'basic', preferredTime: 'morning' },
};
